// src/components/TelegramBrowserWarning.js
import React, { useEffect, useState } from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Typography } from '@mui/material';

const TelegramBrowserWarning = () => {
  const [showWarning, setShowWarning] = useState(false);

  useEffect(() => {
    // Rileva se l'app sta girando in un WebView di Telegram
    if (typeof window.TelegramWebview !== 'undefined' || typeof window.TelegramWebviewProxy !== 'undefined') {
      setShowWarning(true);
    }
  }, []);

  if (!showWarning) return null;

  return (
    <Dialog open={true}>
      <DialogTitle>Browser non supportato</DialogTitle>
      <DialogContent>
        <Typography>
          Sembra che tu stia utilizzando il browser interno di Telegram, in cui il login tramite Google non funziona correttamente.
          Per favore, apri il sito in un browser esterno (come Chrome o Safari).
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={() => setShowWarning(false)} color="primary" variant="contained">
          OK
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default TelegramBrowserWarning;
